import { validateLength } from 'ember-changeset-validations/validators';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { type ValidatorResult } from 'ember-changeset-validations';

export const PropertyCheckOutTaskValidation = {
  description: function (
    key: string,
    newValue: unknown,
    oldValue: unknown,
    changes: Record<string, unknown>,
    content: Record<string, unknown>,
  ): ValidatorResult {
    const model =
      content as unknown as ModelRegistry['property-check-out-task'];
    const IS_ADDITIONAL_REQUESTS = model.type === 'ADDITIONAL_REQUESTS';

    const max = IS_ADDITIONAL_REQUESTS ? 400 : 140;

    return validateLength({ min: 0, max })(
      key,
      newValue,
      oldValue,
      changes,
      content,
    );
  },
};
